<script setup lang="ts">
import { computed } from "vue";
import { formatShortDate } from "@/util/date";
import { convertToLocalTime } from "date-fns-timezone";
import { isAfter, parseISO } from "date-fns";
import useAwards from "@/composables/use-awards";
import { useAuthStore } from "@/stores";

const { instance, instances, settings } = useAwards();
const authStore = useAuthStore();

const verificationStepsActive = computed(() => {
  return true;
  // const timeZone = settings.value?.timezone;
  // const nominationStartDate = instance.value?.nominationStartDate;
  // if (!timeZone || !nominationStartDate) {
  //   return false;
  // }
  // const nominationStart = convertToLocalTime(parseISO(nominationStartDate), {
  //   timeZone,
  // });
  // const now = new Date();
  // return isAfter(now, nominationStart);
});

const finalizeNomineesActive = computed(() => {
  return true;
  // const timeZone = settings.value?.timezone;
  // const nominationStartDate = instance.value?.nominationStartDate;
  // if (!timeZone || !nominationStartDate) {
  //   return false;
  // }
  // const nominationStart = convertToLocalTime(parseISO(nominationStartDate), {
  //   timeZone,
  // });
  // const now = new Date();
  // return isAfter(now, nominationStart);
});

const finalizeFinalistsActive = computed(() => {
  const timeZone = settings.value?.timezone;
  const votingEndDate = instance.value?.votingEndDate;
  if (!timeZone || !votingEndDate) {
    return false;
  }
  const votingEnd = convertToLocalTime(parseISO(votingEndDate), { timeZone });
  const now = new Date();
  return isAfter(now, votingEnd);
});

const awardsCeremonyActive = computed(() => {
  return true;
});
</script>

<template>
  <Card
    class="flex w-full max-w-md flex-col justify-between"
    title="Awards Management"
  >
    <div v-if="instance">
      <router-link
        v-if="authStore.user.roles.includes('AwardsTimeline')"
        class="block text-link-blue"
        to="/award-settings"
        >Award Settings</router-link
      ><span v-else class="text-gray-500">Award Settings</span>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        v-if="authStore.user.roles.includes('Verification')"
        class="block w-40 text-link-blue"
        to="/preselect-nominees"
        >Preselect Nominees</router-link
      ><span v-else class="text-gray-500">Preselect Nominees</span>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        v-if="authStore.user.roles.includes('Verification')"
        class="block w-40 text-link-blue"
        to="/quick-nominate"
        >Quick Nominate</router-link
      ><span v-else class="text-gray-500">Quick Nominate</span>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <div class="mb-2">
        Nomination Period
        <span class="" v-if="instance?.nominationEndDate">
          until {{ formatShortDate(instance.nominationEndDate) }}
        </span>
      </div>
      <router-link
        to="/verify-new-nominees"
        class="ml-8 block text-link-blue"
        v-if="
          verificationStepsActive &&
          authStore.user.roles.includes('Verification')
        "
        >Verify New Nominees</router-link
      >
      <p class="ml-8 text-gray-500" v-else>Verify New Nominees</p>
      <router-link
        to="/verify-existing-nominees"
        class="ml-8 block text-link-blue"
        v-if="
          verificationStepsActive &&
          authStore.user.roles.includes('Verification')
        "
        >Verify Existing Nominees</router-link
      >
      <p class="ml-8 text-gray-500" v-else>Verify Existing Nominees</p>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        class="block text-link-blue"
        to="/finalize-nominees"
        v-if="
          finalizeNomineesActive &&
          authStore.user.roles.includes('FinalizeNominees')
        "
        >Finalize Nominees</router-link
      >
      <p class="text-gray-500" v-else>Finalize Nominees</p>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        class="block text-link-blue"
        to="/claim-nominations"
        v-if="
          finalizeNomineesActive &&
          authStore.user.roles.includes('ReconcileClaimedNominations')
        "
      >
        Reconcile Claimed Nominations
      </router-link>
      <p class="text-gray-500" v-else>Reconcile Claimed Nominations</p>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <div>
        Voting Period
        <span class="ml-4">
          {{ formatShortDate(instance?.votingStartDate) }} -
          {{ formatShortDate(instance?.votingEndDate) }}
        </span>
      </div>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        class="block text-link-blue"
        to="/finalize-finalists"
        v-if="
          finalizeFinalistsActive &&
          authStore.user.roles.includes('FinalizeFinalists')
        "
        >Finalize Finalists</router-link
      >
      <p class="text-gray-500" v-else>Finalize Finalists</p>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        class="block text-link-blue"
        to="/finalize-winners"
        v-if="
          finalizeFinalistsActive &&
          authStore.user.roles.includes('FinalizeWinners')
        "
        >Finalize Winners</router-link
      >
      <p class="text-gray-500" v-else>Finalize Winners</p>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        to="/finalize-master-categories"
        class="text-link-blue"
        v-if="
          finalizeFinalistsActive &&
          authStore.user.roles.includes('FinalizeWinners')
        "
        >Finalize Master Category Winners</router-link
      >
      <p class="text-gray-500" v-else>Finalize Master Category Winners</p>
      <div class="flex w-40 justify-center py-2">
        <font-awesome-icon icon="angle-down" />
      </div>
      <router-link
        to="/awards-ceremony-registration"
        class="text-link-blue"
        v-if="
          awardsCeremonyActive &&
          authStore.user.roles.includes('AwardsCeremonyRegistration')
        "
        >Awards Ceremony Registration</router-link
      >
      <p class="text-gray-500" v-else>Awards Ceremony Registration</p>
    </div>

    <div class="mt-4 flex w-full items-center justify-center">
      <Button @click="() => $router.push('/initial-setup')">
        {{ instances[0]?.isDraft ? "Edit Draft" : "Setup Next Award Year" }}
      </Button>
    </div>
  </Card>
</template>
